
      import Qrcode from './qrcode.vue'
      import type { App, Plugin } from 'vue'

      export const QrcodePlugin: Plugin = {
        install(app: App) {
          app.component('Qrcode', Qrcode)
        },
      }
      export { Qrcode }
      